
import * as type from './types';

export function removeAlbumFile(data) {
    return {
        type: type.REMOVE_ALBUM_FILE_REQUESTED,
        data: data,
    }
}